<template>
  <v-container class="py-5">
    <v-card class="py-5" elevation="1">
      <v-card-title class="pa-8">
        <v-layout row wrap>
          <v-row>
            <h3 class="pl-4">
              <v-icon class="mr-2" color="primary" size="32">mdi-table-account</v-icon>
              Workforce Group By Professional Category Facility type and Sex
            </h3>
          </v-row>
          <v-spacer></v-spacer>
          <v-row class="pr-4 pt-8" justify="end">
            <fhir-reference
                :initialValue="`Location/${getData.facilityId}`"
                baseMax="1"
                baseMin="0"
                constraints=undefined
                display-type="tree"
                edit=true
                field="partOf"
                label="Facility"
                max="1"
                min="0"
                path="Location.partOf"
                readOnlyIfSet:undefined
                returnAll=true
                sliceName:undefined
                slotProps:Object
                source:Object
                subFields:undefined
                targetProfile="http://ihris.org/fhir/StructureDefinition/ihris-facility"
                targetResource="Location"
                @selectFacilityForDashboard="onSelectedFacility"
            >
            </fhir-reference>
            <v-btn
                class="mr-2 mt-3"
                color="primary"
                @click="dataExportCSV"
            >
              <v-icon left>mdi-microsoft-excel</v-icon>
              Export Report
            </v-btn>
          </v-row>
        </v-layout>
      </v-card-title>
      <v-divider class="my-2"></v-divider>
      <v-card-text id="healthWorkersGenderDistribution">
        <v-data-table
            v-if="!loading"
            id="healthWorkersGenderDistributionTableRatio"
            :headers="headers"
            :items="data"
            :items-per-page="5"
            class="transparent elevation-3 my-4"
            disable-pagination
            disable-sort
            hide-default-footer
            hide-default-header
        >
          <template #header="{ }">
            <thead class="v-data-table-header">
            <tr>
              <th v-for="(h,i) in headers" :key="i" :colspan="h.colspan"
                  :rowspan="h.rowspan" class="text-center parent-header td-border-style">
                {{ h.text }}
              </th>
            </tr>
            <tr>
              <th v-for="(h1,i1) in getSubHeader(headers)" :key="i1" :colspan="h1.colspan" :rowspan="h1.rowspan"
                  class="text-center child-header td-border-style">
                {{ h1.text }}
              </th>
            </tr>
            <tr>
              <th v-for="(h2,i1) in getSubSubHeader(headers)" :key="i1" :colspan="h2.colspan" :rowspan="h2.rowspan"
                  class="text-center child-header td-border-style">
                {{ h2.text }}
              </th>
            </tr>
            </thead>
          </template>
          <template #item="props">
            <tr>
              <td>{{ props.item.professionCategory.display }}</td>
              <td>{{ props.item.healthPost.urban.male }}</td>
              <td>{{ props.item.healthPost.urban.female }}</td>
              <td>{{ props.item.healthPost.rural.male }}</td>
              <td>{{ props.item.healthPost.rural.female }}</td>
              <td>{{ props.item.healthCenter.urban.male }}</td>
              <td>{{ props.item.healthCenter.urban.female }}</td>
              <td>{{ props.item.healthCenter.rural.male }}</td>
              <td>{{ props.item.healthCenter.rural.female }}</td>
              <td>{{ props.item.primaryHospital.urban.male }}</td>
              <td>{{ props.item.primaryHospital.urban.female }}</td>
              <td>{{ props.item.primaryHospital.rural.male }}</td>
              <td>{{ props.item.primaryHospital.rural.female }}</td>
              <td>{{ props.item.generalHospital.male }}</td>
              <td>{{ props.item.generalHospital.female }}</td>
              <td>{{ props.item.referralHospital.male }}</td>
              <td>{{ props.item.referralHospital.female }}</td>
              <td>{{ props.item.grandTotal.male }}</td>
              <td>{{ props.item.grandTotal.female }}</td>
              <td>{{ props.item.grandTotal.total }}</td>
            </tr>
          </template>
          <template slot="body.append">
            <tr class="pink--text">
              <th>Total</th>
              <th>{{ sumField('healthPost.urban.male') }}</th>
              <th>{{ sumField('healthPost.urban.female') }}</th>
              <th>{{ sumField('healthPost.rural.male') }}</th>
              <th>{{ sumField('healthPost.rural.female') }}</th>
              <th>{{ sumField('healthCenter.urban.male') }}</th>
              <th>{{ sumField('healthCenter.urban.female') }}</th>
              <th>{{ sumField('healthCenter.rural.male') }}</th>
              <th>{{ sumField('healthCenter.rural.female') }}</th>
              <th>{{ sumField('primaryHospital.urban.male') }}</th>
              <th>{{ sumField('primaryHospital.urban.female') }}</th>
              <th>{{ sumField('primaryHospital.rural.male') }}</th>
              <th>{{ sumField('primaryHospital.rural.female') }}</th>
              <th>{{ sumField('generalHospital.male') }}</th>
              <th>{{ sumField('generalHospital.female') }}</th>
              <th>{{ sumField('referralHospital.male') }}</th>
              <th>{{ sumField('referralHospital.female') }}</th>
              <th>{{ sumField('grandTotal.male') }}</th>
              <th>{{ sumField('grandTotal.female') }}</th>
              <th>{{ sumField('grandTotal.total') }}</th>
            </tr>
          </template>
        </v-data-table>
        <h1 v-else>
          <v-col
              class="h5 text-center"
              cols="12"
          >
            Loading The Report ...
          </v-col>
          <v-row
              align-content="center"
              class="fill-height"
              justify="center"
          >
            <v-col class="my-12" cols="6">
              <v-progress-linear
                  color="primary"
                  height="6"
                  indeterminate
                  rounded
              ></v-progress-linear>
            </v-col>
          </v-row>
        </h1>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import _ from 'lodash'
import XLSX from "xlsx";
import FhirReference from "@/components/fhir/fhir-reference.vue";

export default {
  components: {FhirReference},
  methods: {
    getSubHeader(headers) {
      let result = [];
      headers
          .filter((i) => i.children)
          .forEach((v) => {
            result = result.concat(v.children);
          });
      return result;
    },
    getSubSubHeader(headers) {
      let result = [];
      headers
          .filter((i) => i.children)
          .forEach((v) => {
            if (v.children) {
              let a = v.children;
              a.filter((i) => i.children).forEach((b) => {
                result = result.concat(b.children);
              });
            }
          });
      return result;
    },
    dataExportCSV() {
      let tbl = document.getElementById("healthWorkersGenderDistributionTableRatio");
      const wb = XLSX.utils.table_to_book(tbl);
      XLSX.writeFile(wb, "Workforce_Group_By_Professional_Category_Facility_type_and_Sex.xlsx");
    },
    getRows(rows) {
      const result = {};
      _.forEach(rows, (i, key) => {
        if (i.children) {
          _.forEach(i.children, (i1, key1) => {
            result["c" + key1] = i1;
          });
        } else result[key] = i;
      });
      return result;
    },
    sumField(key) {
      let keys = key.split(".");
      if (keys.length === 1) {
        return this.data.reduce((a, b) => a + (Number(b[keys[0]]) || 0), 0);
      } else if (keys.length === 2) {
        return this.data.reduce((a, b) => a + (Number(b[keys[0]][keys[1]]) || 0), 0);
      } else if (keys.length === 3) {
        return this.data.reduce((a, b) => a + (Number(b[keys[0]][keys[1]][keys[2]]) || 0), 0);
      }
    },
    onSelectedFacility: function (value) {
       if(value.startsWith("type-")) {
        this.selectedType = value.split("type-").pop()
        this.userFacilityId = "federal-ministry-of-health"
      }else{
        this.selectedType = undefined
        this.userFacilityId = value.split('/').pop()
      }
    },
    setupData() {
      this.loading = true;
      this.data = [
        {
          professionCategory: {
            code: "administrative-staff-diploma-coc",
            display:
                "Administrative Staff (Non-Health Profession):College Diploma/Vocational COC Certificate/10+3/",
            definition:
                "administrative staff (non-health profession):college diploma/vocational coc certificate/10+3/",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "administrative-staff-degree-masters-phd",
            display: "Administrative Staff (Non-Health Profession):Degree/Master/PhD",
            definition:
                "administrative staff (non-health profession):degree/master/phD",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "administrative-staff-8-12",
            display:
                "Administrative Staff (Non-Health Profession):From Grade 8 to 12",
            definition:
                "administrative staff (non-health profession):from grade 8 to 12",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "anesthesia",
            display: "Anesthesia",
            definition: "anesthesia",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "audiometry",
            display: "Audiometry",
            definition: "audiometry",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "biomedical-technology",
            display: "Biomedical Technology",
            definition: "biomedical technology",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "dental-science",
            display: "Dental Science",
            definition: "dental science",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "emergency-and-critical",
            display: "Emergency and Critical",
            definition: "paramedics professionals emergency medical technician",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "environmental-occupational-health",
            display: "Environmental & Occupational Health",
            definition: "environmental occupational health",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "forensic-medicine",
            display: "Forensic Medicine",
            definition: "forensic medicine",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "heahlth-assistant",
            display: "Health Assistant",
            definition: "health assistant",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "health-extension",
            display: "Health Extension/Family health",
            definition: "health extension or family health",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "health-information-technology",
            display: "Health Information Technology",
            definition: "health information technology",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "medical-doctor",
            display: "Medical Doctor",
            definition: "medical doctor",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "medical-laboratory",
            display: "Medical Laboratory",
            definition: "medical laboratory",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "medical-pharmacy",
            display: "Medical Pharmacy",
            definition: "medical pharmacy",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "midwifery",
            display: "Midwifery",
            definition: "midwifery",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "nursing",
            display: "Nursing",
            definition: "nursing",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "opthalmology",
            display: "Opthalmology",
            definition: "opthalmology",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "other-bsc-professionals",
            display: "Other BSc Professionals",
            definition: "other bsc professionals",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "other-mSc-professional-specialist",
            display: "Other MSc Professional Specialist",
            definition: "other mSc professional specialist",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "other-professionals",
            display: "Other Professionals",
            definition: "other professionals",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "paramedics-professionals-emergency-medical-technician",
            display: "Paramedics Professionals: Emergency Medical Technician (EMT)",
            definition: "paramedics professionals emergency medical technician",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "pharmacy",
            display: "Pharmacy",
            definition: "pharmacy",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "physiotheraphy",
            display: " Physiotheraphy",
            definition: "physiotheraphy",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "prostethic-orthothic",
            display: "Prostethic Orthothic",
            definition: "prostethic orthothic",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "psychiatry",
            display: "Psychiatry",
            definition: "psychiatry",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "public-health",
            display: "Public Health",
            definition: "public health",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "public-health-professional-specialist",
            display: "Public Health Professional Specialist",
            definition: "public health professional specialist",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "radiation-therapist",
            display: "Radiation Therapist (RTT)",
            definition: "radiation therapist (RTT)",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "radiology",
            display: "Radiology",
            definition: "radiology",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "specialist",
            display: "Specialist",
            definition: "specialist",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "sub-specialist",
            display: "Sub-Specialist",
            definition: "sub-specialist",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "temporary-transition-positions",
            display: "Temporary Transition Positions",
            definition: "temporary transition positions",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
      ]
      let query = {
        "query": {
          "bool": {
            "must": [
              {
                "script": {
                  "script": {
                    "source": `if(doc['ihris-related-group.keyword'].size() != 0) {if(doc['ihris-related-group.keyword'].value.contains('${this.userFacilityId}')){return true}}`,
                    "lang": "painless"
                  }
                }
              }
            ],
            "must_not": [],
            "filter": []
          }
        },
        "aggs": {
          "professionCategories": {
            "composite": {
              "sources": [
                {
                  "categories": {
                    "terms": {
                      "field": "employeeProfessionCategory.keyword"
                    }
                  }
                },
                {
                  "facilityType": {
                    "terms": {
                      "field": "organizationType.keyword"
                    }
                  }
                },
                {
                  "facilityArea": {
                    "terms": {
                      "field": "facilityArea.keyword"
                    }
                  }
                }
                ,
                {
                  "gender": {
                    "terms": {
                      "field": "gender.keyword"
                    }
                  }
                }
              ],
              "size": 10000
            }
          }
        },
        "reportOptions": {}
      }

      if(this.selectedType){
        let typeName=this.selectedType.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        query = {
        "query": {
          "bool": {
            "must": [
              {
                "script": {
                  "script": {
                    "source": `if(doc['ihris-related-group.keyword'].size() != 0 && doc['organizationType.keyword'].size() !=0) {if(doc['ihris-related-group.keyword'].value.contains('${this.userFacilityId}') && doc['organizationType.keyword'].value=='${typeName}'){return true}}`,
                    "lang": "painless"
                  }
                }
              }
            ],
            "must_not": [],
            "filter": []
          }
        },
        "aggs": {
          "professionCategories": {
            "composite": {
              "sources": [
                {
                  "categories": {
                    "terms": {
                      "field": "employeeProfessionCategory.keyword"
                    }
                  }
                },
                {
                  "facilityType": {
                    "terms": {
                      "field": "organizationType.keyword"
                    }
                  }
                },
                {
                  "facilityArea": {
                    "terms": {
                      "field": "facilityArea.keyword"
                    }
                  }
                }
                ,
                {
                  "gender": {
                    "terms": {
                      "field": "gender.keyword"
                    }
                  }
                }
              ],
              "size": 10000
            }
          }
        },
        "reportOptions": {}
      }
      }

      console.log("query", query)
      const url = `/es/jobposition/_search?filter_path=aggregations`
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(query)
      }).then((response) => response.json().then((result) => {
        result.aggregations.professionCategories.buckets.map((a) => {
          let categories = a.key.categories;
          let facilityType = a.key.facilityType;
          let facilityArea = a.key.facilityArea.toLowerCase();
          let gender = a.key.gender;
          let count = a.doc_count;
          let res = this.data.find((a) => a.professionCategory.code === categories);
          if (facilityType === "Health Post") {
            if (res.healthPost.hasOwnProperty(facilityArea)) {
              if(res.healthPost[facilityArea].hasOwnProperty(gender)){
                res.healthPost[facilityArea][gender] += count;
              }
            }
            res.grandTotal[gender] += count;
            res.grandTotal.total += count;
          }

          if (facilityType === "Health Center") {
            if(res.healthCenter.hasOwnProperty(facilityArea)){
              if(res.healthCenter[facilityArea].hasOwnProperty(gender)){
                res.healthCenter[facilityArea][gender] += count;
              }
            }
            res.grandTotal[gender] += count;
            res.grandTotal.total += count;
          }

          if (facilityType === "Primary Hospital") {
            if (res?.primaryHospital.hasOwnProperty(facilityArea)) {
              if(res.primaryHospital[facilityArea].hasOwnProperty(gender)){
                 res.primaryHospital[facilityArea][gender] += count;
              }
            }
            res.grandTotal[gender] += count;
            res.grandTotal.total += count;
          }

          if (facilityType === "General Hospital") {
            if(res.generalHospital.hasOwnProperty(facilityArea)){
              if(res.generalHospital[facilityArea].hasOwnProperty(gender)){
                res.generalHospital[facilityArea][gender] += count;
              }
            }
            res.grandTotal[gender] += count;
            res.grandTotal.total += count;
          }
          if (facilityType === "Referral Hospital") {
            if(res.referralHospital.hasOwnProperty(facilityArea)) {
              if(res.referralHospital[facilityArea].hasOwnProperty(gender)){
                 res.referralHospital[facilityArea][gender] += count;
              }
            }
            res.grandTotal[gender] += count;
            res.grandTotal.total += count;
          }
        });
        this.loading = false
      })).catch((err) => {
        this.loading = false;
        console.log(err)
      })
    }
  },
  data() {
    return {
      loading: false,
      selectedType:undefined,
      headers: [
        {
          "text": "Health Workforce Category",
          "align": "center",
          "sortable": false,
          "colspan": "1",
          "rowspan": "3",
          "value": "name.display"
        },
        {
          "text": "Health Post",
          "value": "category.prostethicorthothic",
          "colspan": "4",
          "rowspan": "1",
          "children": [
            {
              "text": "Urban",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1",
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "Rural",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1",
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
          ]
        },
        {
          "text": "Health Center",
          "value": "category.midwifery",
          "colspan": "4",
          "rowspan": "1",
          "children": [
            {
              "text": "Urban",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1",
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "Rural",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1",
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
          ]
        },
        {
          "text": "Primary/District Hospital",
          "value": "category.healthextension",
          "colspan": "4",
          "rowspan": "1",
          "children": [
            {
              "text": "Urban",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1",
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "Rural",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1",
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
          ]
        },
        {
          "text": "General Hospital",
          "value": "category.publichealth",
          "colspan": "2",
          "rowspan": "1",
          "children": [
            {
              "text": "M",
              "colspan": "1",
              "rowspan": "2",
            },
            {
              "text": "F",
              "colspan": "1",
              "rowspan": "2",
            },
          ]
        },
        {
          "text": "Referral Hospital",
          "value": "category.othermScprofessionalspecialist",
          "colspan": "2",
          "rowspan": "1",
          "children": [
            {
              "text": "M",
              "colspan": "1",
              "rowspan": "2",
            },
            {
              "text": "F",
              "colspan": "1",
              "rowspan": "2",
            },
          ]
        },
        {
          "text": "Grand Total",
          "value": "category.paramedicsprofessionalsemergencymedicaltechnician",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "M",
              "colspan": "1",
              "rowspan": "2",
              "children": []
            },
            {
              "text": "F",
              "colspan": "1",
              "rowspan": "2",
            },
            {
              "text": "Total",
              "colspan": "1",
              "rowspan": "2",
            },
          ]
        }
      ],
      data: [
        {
          professionCategory: {
            code: "administrative-staff-diploma-coc",
            display:
                "Administrative Staff (Non-Health Profession):College Diploma/Vocational COC Certificate/10+3/",
            definition:
                "administrative staff (non-health profession):college diploma/vocational coc certificate/10+3/",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "administrative-staff-degree-masters-phd",
            display: "Administrative Staff (Non-Health Profession):Degree/Master/PhD",
            definition:
                "administrative staff (non-health profession):degree/master/phD",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "administrative-staff-8-12",
            display:
                "Administrative Staff (Non-Health Profession):From Grade 8 to 12",
            definition:
                "administrative staff (non-health profession):from grade 8 to 12",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "anesthesia",
            display: "Anesthesia",
            definition: "anesthesia",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "audiometry",
            display: "Audiometry",
            definition: "audiometry",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "biomedical-technology",
            display: "Biomedical Technology",
            definition: "biomedical technology",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "dental-science",
            display: "Dental Science",
            definition: "dental science",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "emergency-and-critical",
            display: "Emergency and Critical",
            definition: "paramedics professionals emergency medical technician",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "environmental-occupational-health",
            display: "Environmental & Occupational Health",
            definition: "environmental occupational health",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "forensic-medicine",
            display: "Forensic Medicine",
            definition: "forensic medicine",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "heahlth-assistant",
            display: "Health Assistant",
            definition: "health assistant",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "health-extension",
            display: "Health Extension/Family health",
            definition: "health extension or family health",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "health-information-technology",
            display: "Health Information Technology",
            definition: "health information technology",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "medical-doctor",
            display: "Medical Doctor",
            definition: "medical doctor",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "medical-laboratory",
            display: "Medical Laboratory",
            definition: "medical laboratory",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "medical-pharmacy",
            display: "Medical Pharmacy",
            definition: "medical pharmacy",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "midwifery",
            display: "Midwifery",
            definition: "midwifery",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "nursing",
            display: "Nursing",
            definition: "nursing",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "opthalmology",
            display: "Opthalmology",
            definition: "opthalmology",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "other-bsc-professionals",
            display: "Other BSc Professionals",
            definition: "other bsc professionals",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "other-mSc-professional-specialist",
            display: "Other MSc Professional Specialist",
            definition: "other mSc professional specialist",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "other-professionals",
            display: "Other Professionals",
            definition: "other professionals",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "paramedics-professionals-emergency-medical-technician",
            display: "Paramedics Professionals: Emergency Medical Technician (EMT)",
            definition: "paramedics professionals emergency medical technician",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "pharmacy",
            display: "Pharmacy",
            definition: "pharmacy",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "physiotheraphy",
            display: " Physiotheraphy",
            definition: "physiotheraphy",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "prostethic-orthothic",
            display: "Prostethic Orthothic",
            definition: "prostethic orthothic",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "psychiatry",
            display: "Psychiatry",
            definition: "psychiatry",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "public-health",
            display: "Public Health",
            definition: "public health",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "public-health-professional-specialist",
            display: "Public Health Professional Specialist",
            definition: "public health professional specialist",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "radiation-therapist",
            display: "Radiation Therapist (RTT)",
            definition: "radiation therapist (RTT)",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "radiology",
            display: "Radiology",
            definition: "radiology",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "specialist",
            display: "Specialist",
            definition: "specialist",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "sub-specialist",
            display: "Sub-Specialist",
            definition: "sub-specialist",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
        {
          professionCategory: {
            code: "temporary-transition-positions",
            display: "Temporary Transition Positions",
            definition: "temporary transition positions",
          },
          healthPost: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          healthCenter: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          primaryHospital: {
            urban: {
              male: 0,
              female: 0,
            },
            rural: {
              male: 0,
              female: 0,
            },
          },
          generalHospital: {
            male: 0,
            female: 0,
          },
          referralHospital: {
            male: 0,
            female: 0,
          },
          grandTotal: {
            male: 0,
            female: 0,
            total: 0,
          },
        },
      ],
      userFacilityId: this.$store.state.user.facilityId,
    };
  },
  created() {
    this.setupData()
  },
  computed: {
    getData() {
      return this.$store.state.user
    }
  },
  watch: {
    userFacilityId: function () {
      this.setupData()
    },
    selectedType: function () {
      this.setupData()
    }
  }
}
</script>
<style lang="sass">
#healthWorkersGenderDistribution
  $record-text-size: 16px

  .record-item-value
    font-size: $record-text-size
    border-bottom: thin #0c0c0c

  .record-item-unit
    font-size: $record-text-size

  .record-item-value-border
    border: thin #a1a1a1
    margin-right: 4px

  .record-item-key
    font-weight: bold
    font-size: $record-text-size

  .record-content
    border: thin #a1a1a1

  .v-data-table
    td
      padding: 12px 8px
      font-size: $record-text-size
      border-color: rgba(0, 0, 0, 0.12)
      border-style: solid
      border-left-width: 0px
      border-right-width: thin
      border-top-width: 0px
      border-bottom-width: thin
      color: black

    tr
      &:nth-of-type(even)
        background-color: #ced7e1

    th
      border-color: rgb(112, 109, 109)
      border-style: solid
      border-left-width: 0px
      border-right-width: thin
      border-top-width: 0px
      border-bottom-width: thin
      color: white
      background-color: #0d3552
      letter-spacing: 0.03em
      font-size: 14px


  .v-data-table table
    //border: thin 1px #f1f0f0
    border-radius: 5px

  .v-data-table table thead tr th
    font-weight: bold
    font-size: $record-text-size
    padding: 0px 8px

  .v-data-table table tbody tr td .v-btn
    margin-right: 0px !important

  .v-data-table .v-data-table-header__sort-badge
    font-size: 10px

  .v-data-table.theme--dark
    tr th
      color: #9b2323 !important

  .theme--light
    .v-data-table table thead tr th
      color: black

    .v-data-table table thead tr td
      color: black

</style>
